import { render } from "./ScrollableMarketplaceList.vue?vue&type=template&id=4f099eda&scoped=true"
import script from "./ScrollableMarketplaceList.vue?vue&type=script&lang=js"
export * from "./ScrollableMarketplaceList.vue?vue&type=script&lang=js"

import "./ScrollableMarketplaceList.vue?vue&type=style&index=0&id=4f099eda&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f099eda"]])

export default __exports__